import React, { useContext } from 'react';

import { Context } from '@store/store';

import { Wrapper, Page, Text } from './item.styles';

const Item = ({ page, text }) => {
  const [state, dispatch] = useContext(Context);

  return (
    <Wrapper>
      <Page
        onClick={() => {
          const pageToGoTo = state.isSinglePageMode
            ? page - 1
            : page === 1
            ? 0
            : Math.floor(page / 2);
          dispatch({
            type: 'SET_CURRENT_PAGE',
            payload: pageToGoTo,
          });
          dispatch({ type: 'TOGGLE_SEARCH_SIDEBAR' });
        }}
      >
        Стр. {page}
      </Page>
      <Text className="search-result">{text}</Text>
    </Wrapper>
  );
};

export default Item;
